module.exports = __webpack_public_path__ + "static/media/主页面[新]_02.0190674b.jpg";